export default "__VITE_ASSET__BJLk5Ifw__"